var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 32,
    viewBox: "0 0 160 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#6369D1",
    strokeWidth: 2,
    d: "M0 65L0 0 160 0 160 65"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(35 16)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#6369D1",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.781 11.563L5.922 29.5M11.422 6L73.422 6M11.422 35L27.422 35M19.422 12.719H35.422V21.719H19.422zM42.422 12.719H58.422V21.719H42.422zM65.422 12.719H81.422V21.719H65.422z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.781,
    cy: 5.781,
    r: 5.781
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.781,
    cy: 34.781,
    r: 5.781
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.422 41.719H35.422V50.719H19.422zM27.422 13L27.422 6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M27.422 41L27.422 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.422 13L50.422 6"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M73.422 12V6"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragTasks);
export default __webpack_public_path__ + "static/media/frag_tasks.b1e427255880d3bd69e18b14ff48322e.svg";
export { ForwardRef as ReactComponent };